import React from 'react';
import { IconArrowUpRight } from '@tabler/icons-react';
import { openExternalURL } from '@/utils/external-link-utils';
import styles from './privacy-security.module.css';

const PrivacyAndSecurity: React.FC = () => {
  const handlePrivacyPolicyClick = () => {
    openExternalURL('https://maatra.health/privacy');
  };

  const handleTermsClick = () => {
    openExternalURL('https://maatra.health/terms');
  };

  return (
    <div className={styles.pageContainer}>
      <h1 className={styles.pageTitle}>Privacy is <br/> personal to us</h1>
      
      <div className={styles.contentCard}>
        {/* Section 1 - Purple text */}
        <p className={styles.primaryText}>
          When we started Maatra, we asked ourselves a simple question: <strong>would we be comfortable storing our own parents’ medical records here?</strong>
        </p>
        
        <p className={styles.secondaryText}>
          That question guides every decision we make about privacy at Maatra.
        </p>

        {/* Section 2 - Regular text */}
        <p className={styles.secondaryText}>
          All health documents are handled by software, not by people. No one at Maatra opens, reads, or browses your records. Your data is protected from the moment it leaves your phone and while it is stored with us, using industry-standard security.
        </p>

        <p className={styles.secondaryText}>
          When you send documents through WhatsApp or email, they are securely moved into your Maatra account. Any temporary copies created during processing are deleted once the job is done.
        </p>

        <p className={styles.secondaryText}>
          We don't sell your data. We don't share it with advertisers. We don't use your data to train AI models.
        </p>

        <p className={styles.secondaryText}>
          Your data belongs to you. You decide who in your family can see what. And if you ever choose to leave Maatra, your health records are removed from our systems. We keep a separate, secure record of your consent and key account actions for three years to meet legal requirements and protect your rights.
        </p>

        <p className={styles.secondaryText}>
          We're building Maatra for the long term, and your trust matters more to us than anything else.
        </p>

        <p className={styles.secondaryText}>
          Thank you for trusting us with your family's care.
        </p>

        <p className={styles.secondaryText}>
          If you have questions, you can always reach us directly.
        </p>

        <p className={styles.secondaryText}>
          Team Maatra
        </p>

        {/* Links Section */}
        <div className={styles.linksContainer}>
          <button 
            className={styles.linkButton}
            onClick={handlePrivacyPolicyClick}
          >
            <IconArrowUpRight size={24} />
            <span>Privacy policy</span>
          </button>

          <button 
            className={styles.linkButton}
            onClick={handleTermsClick}
          >
            <IconArrowUpRight size={24} />
            <span>Terms of use</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyAndSecurity;
